import { render, staticRenderFns } from "./ProjetosTable.vue?vue&type=template&id=4a50f118&"
import script from "./ProjetosTable.vue?vue&type=script&lang=js&"
export * from "./ProjetosTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports